import { useQuery } from '@tanstack/react-query';

import { makeRequest } from '@app/utils';
import { FETCH_LIMIT } from '@app/constants';

export interface LocationDto {
  id: string;
  name: string;
  code: string;
  isActive: boolean;
  institutionId: string;
  campusId: string;
  libraryId: string;
  primaryServicePoint: string;
  discoveryDisplayName?: string;
}

export interface LocationsDto {
  locations: LocationDto[];
}

export const useLocationsFetch = () =>
  useQuery<LocationsDto, unknown, LocationsDto['locations']>(
    ['locations'],
    () =>
      makeRequest<LocationsDto>({
        url: '/opac-inventory/locations',
        params: { limit: FETCH_LIMIT },
      }),
    {
      refetchOnMount: false,
      select: ({ locations }) => locations,
    }
  );
